<template>
    <div style="background-color: #eeeeee;padding-bottom: 100px;">
        <img style="display: block;margin: 0 auto;" src="../../assets/banner9.png" alt="">
        <div class="main">
            <ul class="Breadcrumb">
                <li @click="backPage('/home')">首页</li>
                <li>></li>
                <li>公司介绍</li>
            </ul>
            <h3 class="tab_title">公司简介</h3>
            <p style='margin-bottom:20px;'>{{form.content}}</p>
            <div v-if="technologyList.length>0" class="promotional">
                            <video ref="video" style="width:100%" muted="muted" class="video" :poster="form.coverImage"
                                :src="form.video" type="video/mp4" controls="controls">
                                <p>你的浏览器不支持video标签.</p>
                            </video>
                            <!-- <span>{{ technologyList[0].name }}</span> -->
                        </div>
            <h3 class="tab_title">公司资质</h3>

            <img style="margin:20px 0" :src="form.titleImage" alt="" />
            <!-- <img style="margin:20px 0" src="../../assets/img29.jpg" alt="" /> -->
            <!-- <h3 class="tab_title">投资伙伴</h3> -->
        </div>
        <!-- <div class="swiper_wrap anTransform" style="width:1300px;margin:0 auto;overflow: hidden;">
                <swiper id="media" class="homeSwiper" :options="swiperOption" ref="mySwiper">
                <swiper-slide v-for="(item, index) in swiperList" :key="index">
                    <img :src="item.coverImage" alt="" />
                </swiper-slide>
            </swiper>
            <div class="fleft bg"></div>
            <div class="fright bg"></div>
        </div> -->
    </div>
</template>
<script>
import {backPage} from '@/utils/common'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { getVideoList,getPromotionalVideo } from '../../api/index'

// import 'swiper/dist/css/swiper.css'
export default {
    components: {
        swiper,
        swiperSlide,
    },
    data() {
        return {
            technologyList: [],
            swiperOption: {
                slidesPerView: 4.5,
                slidesPerColumn: 2,
                spaceBetween: 10,
                // pagination: {
                //     el: '.swiper-pagination',
                //     clickable: true,
                // },
                // autoplay: {
                //     delay: 1000,
                //     stopOnLastSlide: false,
                //     disableOnInteraction: true,
                // },
                
            },
            swiperList: [
                { coverImage: require('../../assets/logo/logo1.png') },
                { coverImage: require('../../assets/logo/logo2.png') },
                { coverImage: require('../../assets/logo/logo3.png') },
                { coverImage: require('../../assets/logo/logo4.png') },
                { coverImage: require('../../assets/logo/logo5.png') },
                { coverImage: require('../../assets/logo/logo6.png') },
                { coverImage: require('../../assets/logo/logo7.png') },
                { coverImage: require('../../assets/logo/logo8.png') },
                { coverImage: require('../../assets/logo/logo9.png') },
                { coverImage: require('../../assets/logo/logo10.png') },
                { coverImage: require('../../assets/logo/logo11.png') },
                { coverImage: require('../../assets/logo/logo12.png') },
                { coverImage: require('../../assets/logo/logo13.png') },
                { coverImage: require('../../assets/logo/logo14.png') },
            ],
            form:{}
        }
    },
    mounted(){
        // document.getElementsByClassName('homeSwiper')[0].removeAttribute('overflow')
        // this.$refs.mySwiper.removeClass('swiper-container')
        getVideoList({ promotional: '1' }).then(res => {
            this.technologyList = res.rows
        })
        getPromotionalVideo().then(res =>{
            console.log(res.data);
            this.form = res.data
        })
    },
    methods:{
        backPage
    }
}
</script>
<style lang="scss" scoped>
.title {
    border-left: 10px solid #d60e4c;
    line-height: 32px;
    text-indent: 30px;
    font-weight: bold;
    font-size: 36px;
    margin: 30px 0;
}

p {
    line-height: 32px;
    font-size: 16px;
}

.swiper_wrap {
    position: relative;

    .bg {
        height: 100%;
        position: absolute;
        width: 150px;
        top: 0;
        z-index: 999;
    }

    .bg.fleft {
        background-image: linear-gradient(to right, #eeeeee, transparent);
        left: 0;
    }

    .bg.fright {
        background-image: linear-gradient(to left, #eeeeee, transparent);
        right: 0;
    }

}
#media{
    animation:rolling 10s infinite linear;
}
#media:hover{
    animation-play-state:paused;
}
@keyframes rolling{
    0%{
        transform: translateX(0);
    }
    100%{
        transform: translateX(-800px);
    }
}
.homeSwiper{
    overflow: initial !important;
}
.promotional{
    margin-bottom:30px;
}
</style>


// WEBPACK FOOTER //
// src/views/about/index.vue